import { Button } from "react-bootstrap";
import * as theme from "../theme";

export function OrangeButton(props) {
  const disable = props.disable;
  const text = props.text;
  const onClick = props.onClick;
  const onMouseOver = props.onMouseOver;
  const onMouseLeave = props.onMouseLeave;
  const color = props.color ? props.color : theme.COLORS.secondary_orange;
  const width = props.width ? props.width : "12vmin";
  const minWidth = props.minWidth ? props.minWidth : "6vmin";
  const height = props.height ? props.height : "3.6vmin";
  const maxheight = props.maxheight ? props.maxheight : "3.6vmin";
  const fontSize = props.fontSize ? props.fontSize : "1.5vmin";
  const type = props.type ? props.type : "button";
  return (
    <Button
      style={{
        color: "white",
        height: height,
        maxHeight: maxheight,
        minWidth: width,
        fontFamily: "GibsonLight",
        fontSize: fontSize,
        borderColor: color,
        backgroundColor: color,
        borderRadius: "1.1vmin",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        letterSpacing: 1,
      }}
      type={type}
      disabled={disable}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    >
      {text}
    </Button>
  );
}
